import { createAsyncThunk } from "@reduxjs/toolkit";

import axiosChargebee from "../utils/chargebee";
import axiosHubspot from "../utils/hubspot";
import axiosTenant from "../utils/tenant";

import {
  notification
} from "../actions";

export const getMarquetItems = createAsyncThunk("getMarquetItems", async (payload, thunkAPI) => {
  try {
    const response = await axiosChargebee.get(`/v1/marquet_items?item_family=Marquet-Cloud&currency_code=${payload.currencyCode}&in_portal=True&period=${payload.period}`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})

export const getPlanDetails = createAsyncThunk("getPlanDetails", async (payload, thunkAPI) => {
  try {
    const response = await axiosChargebee.get(`/v1/plans/${payload}/details`);
    if (response && response.data && response.data.success) {
      return response.data
    } else {
      return response.data
    }
  } catch (e) {
    thunkAPI.dispatch(notification({ title: `We are having some issues`, message: `${e.message}`, type: `error` }));
    console.log("Error:", e)
  }
})